import { render } from "./AudienceDashboard.vue?vue&type=template&id=22b52277&scoped=true"
import script from "./AudienceDashboard.vue?vue&type=script&lang=js"
export * from "./AudienceDashboard.vue?vue&type=script&lang=js"

import "./AudienceDashboard.vue?vue&type=style&index=0&id=22b52277&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b52277"]])

export default __exports__